import {FrontWebSongModel} from "../generated";

export const isSongPlay = (now?: FrontWebSongModel | null) => {
    if (!now)
        return false;
    if (!now.endAt)
        return true;
    return new Date(now.endAt) > new Date();
}